<template>
  <div class="component-wrap">
    <div class="input-wrap">
      <input
        readonly="readonly"
        autocomplete="off"
        class="input"
        :value="defaultValue"
        ref="selectInput"
        @blur="BlurFn"
      />
    </div>
    <div class="select-wrap">
      <div class="select" :class="optionsDown ? 'up' : ''" @click="SelectFn">
        {{ defaultValue }}
      </div>
      <div class="options" v-show="optionsDown">
        <ul>
          <li v-for="item in dataList" :key="item.index">
            <p
              class="item"
              v-for="(key, index) in item.Province"
              :key="key"
              :data-key="key"
              @click="SelectAction"
              :class="key == defaultValue ? 'active' : ''"
            >
              <span v-if="index == 0"
                >{{ item.index == "-" ? "" : item.index }} </span
              ><span v-else></span>{{ key }}
            </p>
          </li>
        </ul>
        <!-- <div class="user-operation" v-show="multiple">
        <div class="reset-btn" @click="resetFn">重置</div>
        <div class="confirm-btn" @click="confirmFn">确定</div>
      </div> -->
      </div>

      <div class="bg-shade" v-show="optionsDown" @click="BlurFn"></div>
    </div>
  </div>
</template>

<script>
import { province } from "../util/province.js";
export default {
  props: {
    dataList: {
      type: Array,
      default: function () {
        return province;
      },
    },
    value: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionsDown: false,
      defaultValue: "",
      timer: null,
      multipleList: [], // 多选
    };
  },
  created() {
    this.defaultValue = this.title;
  },
  methods: {
    BlurFn() {
      this.timer = setTimeout(() => {
        this.optionsDown = false;
      }, 0);
    },
    SelectFn() {
      clearTimeout(this.timer);
      this.$refs.selectInput.focus();
      this.optionsDown = !this.optionsDown;
    },
    confirmFn() {
      this.optionsDown = false;
      const obj = this.dataList.filter((item) => {
        return this.multipleList.includes(item.value);
      });
      this.$emit("change", obj);
    },
    SelectAction(e) {
      clearTimeout(this.timer);
      const val = e.target.attributes["data-key"].value;
      this.optionsDown = false;
      this.defaultValue = val == "全部省份" ? "地域" : val;
      this.$emit("change", this.defaultValue);
    },
  },
};
</script>


<style scoped lang="scss">
.component-wrap {
  position: relative;
  .input-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 0;
    height: 0;
    overflow: hidden;
  }
  .input {
    opacity: 0;
    display: inline-block;
    position: absolute;
  }
}

.select-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  overflow: hidden;

  .select {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
    position: relative;
    font-size: 3.733vw;
    color: #7288a6;
    // border-bottom: solid 0.133vw #eeeeee;
    &::after {
      content: "";
      border-top: solid 1.067vw #ccc;
      border-left: 0.933vw solid transparent;
      border-right: 0.933vw solid transparent;
      margin-left: 0.667vw;
    }
  }
  .select.up {
    color: #111111;
    &::after {
      content: "";
      border-top: none;
      border-bottom: solid 1.067vw #ccc;
      border-left: 0.933vw solid transparent;
      border-right: 0.933vw solid transparent;
      margin-left: 0.667vw;
    }
  }
  ul {
    padding: 0;
    margin: 0;
    // box-shadow: 0 1px 3px 0 #eeeeee;
    li {
      list-style-type: none;
      font-size: 3.733vw;
      &:last-child {
        //border-bottom: solid 0.133vw #eeeeee;
        border-bottom: none;
      }
    }
    li.active {
      color: #71a209;
    }
  }
  .user-operation {
    border-top: solid 0.133vw #ccc;
    height: 10.667vw;
    display: flex;
    div {
      flex: 1;
      line-height: 10.667vw;
      font-size: 4.267vw;
      text-align: center;
    }
    .reset-btn {
      color: #7288a6;
      border-right: solid 0.133vw #ccc;
    }
    .confirm-btn {
      color: #71a209;
    }
  }
  .bg-shade {
    position: fixed;
    height: 146vw;
    width: 100vw;
    left: 0;
    background: rgba($color: #000000, $alpha: 0.3);
  }
  .options {
    position: fixed;
    width: 100vw;
    left: 0;
    background: #fff;
    z-index: 2;
  }
}
.options {
  height: 146vw;
  overflow-y: scroll;
  p {
    padding: 0;
    margin: 0;
  }
  .item {
    text-align: left;
    padding: 3.467vw 0;
  }
}
.item {
  span {
    text-align: center;
    display: inline-block;
    width: 8vw;
  }
}
</style>